var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoImageNotSupported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.475 23.3L18.175 21H5.00001C4.45001 21 3.97918 20.8041 3.58751 20.4125C3.19585 20.0208 3.00001 19.55 3.00001 19V5.82498L0.700012 3.49998L2.10001 2.09998L21.9 21.9L20.475 23.3ZM5.00001 19H16.175L14.175 17H6.00001L9.00001 13L11 15.725L11.85 14.675L5.00001 7.82498V19ZM21 18.175L19 16.175V4.99998H7.82501L5.82501 2.99998H19C19.55 2.99998 20.0208 3.19581 20.4125 3.58748C20.8042 3.97914 21 4.44998 21 4.99998V18.175Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoImageNotSupported);
export default __webpack_public_path__ + "static/media/ico-image-not-supported.cd261a204f6b621cf01dcbf6a69da7ac.svg";
export { ForwardRef as ReactComponent };